<form #workareaForm="ngForm">
    <div class="row">
        <div class="col-24 col-md-8">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Boorlocatie</mat-label>
                <mat-select
                    #drillLocation="ngModel"
                    (valueChange)="inputChanged($event)"
                    [(ngModel)]="workarea.extra.drillLocation"
                    errorState="drillLocation.errors?.required && (drillLocation.dirty || workareaForm.submitted)"
                    name="drillLocation"
                    required>
                    <mat-option [value]="undefined" disabled selected>Boorlocatie</mat-option>
                    @for (type of fieldOptions['drillLocation']; track type) {
                        <mat-option [value]="type">{{ type }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-8">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Rijstrook</mat-label>
                <input [(ngModel)]="workarea.extra.lane" [matAutocomplete]="auto" matInput name="lane" type="text" />
                <mat-autocomplete #auto="matAutocomplete">
                    @for (option of fieldOptions['lanes']; track option) {
                        <mat-option [value]="option">
                            {{ option }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-8">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Lengte boorkern</mat-label>
                <input
                    [(ngModel)]="workarea.extra.drill_length"
                    matInput
                    name="drill_length"
                    step="0.01"
                    type="number" />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <mat-form-field class="w-100" [floatLabel]="true">
                <mat-label>Opmerkingen</mat-label>
                <textarea [(ngModel)]="workarea.comments" cdkAutosizeMinRows="4" matInput name="comments"></textarea>
            </mat-form-field>
        </div>
    </div>
</form>
